import { Query, QueryResultsAre } from '@jupiterone/jupiter-types';

export const queryCausesGap = ({ name, resultsAre, lastResult }: Query) =>
  (name === 'bad' || resultsAre === QueryResultsAre.BAD) &&
  (lastResult?.recordCount || 0) > 0;
